import React, { useEffect } from "react";
import { Popover } from "react-bootstrap";

const UpdatingPopover = React.forwardRef((render, ref) => {
  useEffect(() => {
    render.scheduleUpdate();
  }, [render]);

  return (
    <Popover ref={ref} {...render}>
      {render.children}
    </Popover>
  );
});

export default UpdatingPopover;
